// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"95":"c804973a571fdd4a","170":"748a35cb51bec1c2","244":"7940b2be3dc6eb33","250":"0346240d4c940c14","651":"671e6def43be0442"}[chunkId] + ".js";
};